(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var mqMobile = window.matchMedia('(max-width: 768px)');

  /* ---------- Sticky header shadow / background ---------- */
  function initHeader() {
    var wrap = $('[data-site-header]'), bar = $('[data-header-bar]');
    if (!wrap) return;
    var on = function () {
      var s = window.scrollY > 10;
      wrap.classList.toggle('shadow-xl', s);
      wrap.classList.toggle('shadow-md', !s);
      if (bar) {
        bar.classList.toggle('bg-cream/95', s);
        bar.classList.toggle('md:backdrop-blur-md', s);
        bar.classList.toggle('bg-theme-bg', !s);
      }
    };
    window.addEventListener('scroll', on, { passive: true });
    on();

    var mt = $('[data-menu-toggle]'), mm = $('[data-mobile-menu]');
    if (mt && mm) mt.addEventListener('click', function () {
      var open = mm.classList.toggle('hidden') === false;
      mt.setAttribute('aria-expanded', open);
      $('[data-icon-open]', mt).classList.toggle('hidden', open);
      $('[data-icon-close]', mt).classList.toggle('hidden', !open);
    });

    var at = $('[data-account-toggle]'), am = $('[data-account-menu]'), ap = $('[data-account-panel]');
    if (at && am) {
      at.addEventListener('click', function () {
        var r = at.getBoundingClientRect();
        ap.style.top = (r.bottom + 8) + 'px';
        ap.style.right = (window.innerWidth - r.right) + 'px';
        am.classList.remove('hidden');
        at.setAttribute('aria-expanded', 'true');
      });
      $$('[data-account-close], [data-account-panel] a', am).forEach(function (el) {
        el.addEventListener('click', function () { am.classList.add('hidden'); at.setAttribute('aria-expanded', 'false'); });
      });
    }

    var so = $$('[data-search-open]'), sm = $('[data-search-modal]');
    if (sm) {
      var open = function () { sm.classList.remove('hidden'); var i = $('[data-search-input]', sm); if (i) setTimeout(function () { i.focus(); }, 30); };
      var close = function () { sm.classList.add('hidden'); };
      so.forEach(function (b) { b.addEventListener('click', open); });
      $$('[data-search-close]', sm).forEach(function (b) { b.addEventListener('click', close); });
      document.addEventListener('keydown', function (e) {
        if ((e.metaKey || e.ctrlKey) && e.key === 'k') { e.preventDefault(); open(); }
        if (e.key === 'Escape') { close(); if (am) am.classList.add('hidden'); }
      });
    }
  }

  /* ---------- Hero carousel ---------- */
  function initHero() {
    $$('[data-hero]').forEach(function (hero) {
      var count = $$('[data-hero-content]', hero).length;
      if (count < 2) return;
      var idx = 0, hovered = false, timer = null;
      var show = function (n) {
        idx = (n + count) % count;
        $$('[data-hero-slide]', hero).forEach(function (s) {
          var on = +s.getAttribute('data-hero-slide') === idx;
          s.classList.add('transition-opacity', 'duration-[600ms]');
          s.classList.toggle('opacity-100', on);
          s.classList.toggle('opacity-0', !on);
        });
        $$('[data-hero-content]', hero).forEach(function (c) { c.classList.toggle('hidden', +c.getAttribute('data-hero-content') !== idx); });
        $$('[data-hero-dot]', hero).forEach(function (d) {
          var on = +d.getAttribute('data-hero-dot') === idx;
          d.className = 'h-0.5 transition-all duration-500 ' + (on ? 'w-8 bg-white' : 'w-2 bg-white/40 hover:bg-white/70');
        });
      };
      var start = function () {
        clearInterval(timer);
        if (hero.getAttribute('data-autoplay') !== 'true' || window.matchMedia('(max-width: 640px)').matches) return;
        timer = setInterval(function () { if (!hovered) show(idx + 1); }, 5000);
      };
      hero.addEventListener('mouseenter', function () { hovered = true; });
      hero.addEventListener('mouseleave', function () { hovered = false; });
      var n = $('[data-hero-next]', hero), p = $('[data-hero-prev]', hero);
      if (n) n.addEventListener('click', function () { show(idx + 1); });
      if (p) p.addEventListener('click', function () { show(idx - 1); });
      $$('[data-hero-dot]', hero).forEach(function (d) { d.addEventListener('click', function () { show(+d.getAttribute('data-hero-dot')); }); });
      var tx = null;
      hero.addEventListener('touchstart', function (e) { tx = e.changedTouches[0].clientX; }, { passive: true });
      hero.addEventListener('touchend', function (e) {
        if (tx === null) return;
        var d = tx - e.changedTouches[0].clientX;
        if (d > 50) show(idx + 1); if (d < -50) show(idx - 1);
        tx = null; clearInterval(timer); setTimeout(start, 5000);
      });
      start();
    });
  }

  /* ---------- Continuous marquee (Essentials + Reels) ---------- */
  function initMarquees() {
    $$('[data-marquee]').forEach(function (root) {
      var track = $('[data-marquee-track]', root);
      if (!track) return;
      var speed = +root.getAttribute('data-speed') || 50;
      var dots = $$('[data-marquee-dots] > div', root);
      var auto = true, dragging = false, resume = null, raf = null, pos = 0, last = 0, moved = false;
      var start = { x: 0, left: 0 };
      var half = function () { return track.scrollWidth / 2; };
      var paint = function () {
        var active = auto && !dragging;
        dots.forEach(function (d, i) {
          d.className = 'h-1.5 rounded-full transition-all duration-300 ' + (!active ? 'bg-accent' : i === 0 ? 'bg-accent w-4' : 'bg-charcoal-300 w-1.5');
        });
      };
      var step = function (t) {
        if (!last) last = t;
        var dt = (t - last) / 1000; last = t;
        pos += speed * dt;
        if (pos >= half()) pos = 0;
        track.scrollLeft = pos;
        raf = requestAnimationFrame(step);
      };
      var play = function () {
        if (reduceMotion || mqMobile.matches || raf) return;
        pos = track.scrollLeft; last = 0; raf = requestAnimationFrame(step);
      };
      var stop = function () { if (raf) cancelAnimationFrame(raf); raf = null; };
      var setAuto = function (v) { auto = v; v ? play() : stop(); paint(); };

      track.addEventListener('mouseenter', function () { clearTimeout(resume); setAuto(false); });
      track.addEventListener('mouseleave', function () { dragging = false; track.classList.remove('cursor-grabbing', 'select-none'); setAuto(true); });
      track.addEventListener('mousedown', function (e) {
        setAuto(false); dragging = true; moved = false;
        start = { x: e.clientX, left: track.scrollLeft };
        track.classList.add('cursor-grabbing', 'select-none'); paint();
      });
      track.addEventListener('mousemove', function (e) {
        if (!dragging) return;
        var dx = e.clientX - start.x;
        if (Math.abs(dx) > 4) moved = true;
        track.scrollLeft = start.left - dx;
      });
      window.addEventListener('mouseup', function () {
        if (!dragging) return;
        dragging = false; track.classList.remove('cursor-grabbing', 'select-none'); paint();
        clearTimeout(resume); resume = setTimeout(function () { setAuto(true); }, 2000);
      });
      track.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
      track.addEventListener('dragstart', function (e) { e.preventDefault(); });
      if (root.hasAttribute('data-reels')) {
        track.addEventListener('touchstart', function () { clearTimeout(resume); setAuto(false); }, { passive: true });
        track.addEventListener('touchend', function () { clearTimeout(resume); resume = setTimeout(function () { setAuto(true); }, 2000); });
      }
      mqMobile.addEventListener('change', function () { stop(); if (auto) play(); });
      paint(); play();
    });
  }

  /* ---------- Reels: lazy video, mute, modal ---------- */
  function initReels() {
    var vids = $$('[data-reel-video]');
    if (!vids.length) return;
    var unmuted = {};
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var v = en.target;
        if (en.isIntersecting) {
          if (v.dataset.src && !v.getAttribute('src')) { v.src = v.dataset.src; v.load(); }
          var p = v.play(); if (p) p.catch(function () {});
        } else v.pause();
      });
    }, { rootMargin: '200px', threshold: 0.1 });
    vids.forEach(function (v) { io.observe(v); });

    var sync = function () {
      vids.forEach(function (v) { v.muted = !unmuted[v.getAttribute('data-reel-id')]; });
      $$('[data-reel-mute]').forEach(function (b) {
        var on = !!unmuted[b.getAttribute('data-reel-mute')];
        b.setAttribute('aria-label', on ? 'Mute video' : 'Unmute video');
        $('[data-icon-unmuted]', b).classList.toggle('hidden', !on);
        $('[data-icon-muted]', b).classList.toggle('hidden', on);
      });
    };
    $$('[data-reel-mute]').forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.stopPropagation();
        var id = b.getAttribute('data-reel-mute');
        unmuted[id] = !unmuted[id]; sync();
      });
    });

    var modal = $('[data-reel-modal]');
    if (!modal) return;
    var mv = $('[data-reel-modal-video]', modal);
    var close = function () {
      modal.classList.add('hidden'); modal.classList.remove('flex');
      mv.pause(); mv.removeAttribute('src'); document.body.style.overflow = '';
      vids.forEach(function (v) { if (v.getAttribute('src')) v.play().catch(function () {}); });
    };
    $$('[data-reel-open]').forEach(function (card) {
      card.addEventListener('click', function () {
        var v = $('[data-reel-video]', card);
        vids.forEach(function (x) { x.pause(); });
        mv.src = v.dataset.src; mv.poster = v.poster || '';
        modal.classList.remove('hidden'); modal.classList.add('flex');
        document.body.style.overflow = 'hidden';
        mv.play().catch(function () {});
      });
    });
    modal.addEventListener('click', function (e) { if (!$('[data-reel-modal-inner]', modal).contains(e.target)) close(); });
    $('[data-reel-close]', modal).addEventListener('click', close);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !modal.classList.contains('hidden')) close(); });
  }

  /* ---------- Recently viewed ---------- */
  var RV_KEY = 'slein:recently-viewed';
  function readRV() { try { return JSON.parse(localStorage.getItem(RV_KEY)) || []; } catch (e) { return []; } }
  function trackRV() {
    var p = window.__sleinProduct;
    if (!p) return;
    try {
      var list = readRV().filter(function (x) { return x.handle !== p.handle; });
      list.unshift(p);
      localStorage.setItem(RV_KEY, JSON.stringify(list.slice(0, 20)));
    } catch (e) {}
  }
  function renderRV() {
    $$('[data-recently-viewed]').forEach(function (sec) {
      var limit = +sec.getAttribute('data-limit') || 10;
      var cur = window.__sleinProduct && window.__sleinProduct.handle;
      var items = readRV().filter(function (x) { return x.handle !== cur; }).slice(0, limit);
      if (!items.length) return;
      var fmt = new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR', minimumFractionDigits: 2, maximumFractionDigits: 2 });
      var grid = $('[data-rv-grid]', sec), tpl = $('[data-rv-item]', sec);
      items.forEach(function (it) {
        var n = tpl.content.firstElementChild.cloneNode(true);
        n.href = it.url;
        var img = $('img', n); if (it.image) { img.src = it.image; img.alt = it.title; } else img.remove();
        $('h3', n).textContent = it.title;
        $('[data-rv-price]', n).textContent = fmt.format(it.price / 100);
        var c = $('[data-rv-compare]', n);
        if (it.compare && it.compare > it.price) c.textContent = fmt.format(it.compare / 100); else c.remove();
        grid.appendChild(n);
      });
      $('[data-rv-count]', sec).textContent = items.length + (items.length === 1 ? ' item' : ' items');
      sec.classList.remove('hidden');
    });
  }

  function init() { initHeader(); initHero(); initMarquees(); initReels(); trackRV(); renderRV(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function () { initHero(); initMarquees(); initReels(); });
})();
